import React from "react"
import useIpdReleaseHook from "./ipdReleaseHook";


const IpdPatient = ({ filterSelectedIpd }) => {
   

    return (
        <div className="ip-patient">
            <div className="card" style={{width: "auto"}}>
                <div className="card-body">
                    <h5 className="card-title">{filterSelectedIpd[0]?.name}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">{filterSelectedIpd[0]?.ipdNo}</h6>
                    <div className="d-flex justify-content-between flex-wrap">
                    <p className="card-text text-muted">Age:{filterSelectedIpd[0]?.age}</p>
                    <p className="card-text text-muted">Gender:{filterSelectedIpd[0]?.gender === "1" ? "Male": "Female"}</p>
                    <p className="card-text text-muted">Mobile:{filterSelectedIpd[0]?.mobile}</p>
                    <p className="card-text text-muted">Billing Mode:{filterSelectedIpd[0]?.billingMode}</p>
                    <p className="card-text text-muted">Admission Date:{new Date(filterSelectedIpd[0]?.admissionDate).toLocaleDateString()}</p>
                    <p className="card-text text-muted">Discharge Status:{filterSelectedIpd[0]?.dischargeStatus}</p>

                    </div>

                </div>
            </div>
        </div>
    );
};


export default IpdPatient;